import React from "react";
import BootstrapTable from 'react-bootstrap-table-next';

import ApiUtils from '../util/ApiUtils';
import UIUtils from '../util/UIUtils';
import SPUtilities from "../util/SPUtilities";
import RespUtils from "../util/RespUtils";
import Utilities from "../util/Utilities";

import StackedBarChart from "../reports/StackedBarChart";
import BaseBarChart from "../reports/BaseBarChart";
import OasisUtils from "../oasis/OasisUtils";

import OasisNetworkNav from './OasisNetworkNav';

class TopBlockSigners extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      signedMissedData: [],
      isLoading: true
    }
  }

  async componentDidMount() {
    const data = await ApiUtils.get("listData?type=topSigners");
    // console.log("data is:", data);

    if (data) {
      // let proposalsData = JSON.parse(JSON.stringify(data));
      // proposalsData.sort((a, b) => (a.proposals > b.proposals) ? 1 : -1)

      let signedMissedData = JSON.parse(JSON.stringify(data));
      signedMissedData.sort((a, b) => (a.signatures > b.signatures) ? -1 : 1)

      this.setState({data: data,
        signedMissedData: signedMissedData, isLoading: false});
    }
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading Block Perf</div>;
    }

    var columns = [
         {text: "Validator", dataField: "entity", formatter: OasisUtils.entityLink, sort: true, headerStyle: Utilities.width(25)},
         {text: "Signs", dataField: "signatures", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
         {text: "Sign %", dataField: "signPer", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
         {text: "Missed", dataField: "notSigned", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
       ];
   //  if (RespUtils.isMobileView()) {
   //    columns = [
   //     {text: "Validator", dataField: "entity", formatter: OasisUtils.entityLink, sort: true, headerStyle: Utilities.width(25)},
   //     {text: "Signs", dataField: "signatures", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
   //     {text: "Sign %", dataField: "signPer", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
   //     {text: "Missed", dataField: "notSigned", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
   //   ];
   // } else {
   //   columns = [
   //    {text: "Validator", dataField: "entity", formatter: OasisUtils.entityLink, sort: true, headerStyle: Utilities.width(25)},
   //    {text: "Signatures", dataField: "signatures", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
   //    {text: "Sign %", dataField: "signPer", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
   //    {text: "Missed Signatures", dataField: "notSigned", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(20)},
   //    {text: "Proposals", dataField: "proposals", sort: true,  sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(15)},
   //  ];
   // }

    const options = UIUtils.getPageOptionsSmall(this, 10);

  	return (
      <div>
        <h5 style={{align: "center"}}><span><strong>7 Day Validator Performance</strong></span>
          <span className="buttonWithText">{UIUtils.renderReloadSize(this, 30)}</span></h5>
        <BaseBarChart title="Top Block Signers" xAxis="Validator" yAxis="Blocks Signed"
          showVerticalLabel={false} valueAttr="signatures" showTotalLabel={false}
          data={this.state.data} xAxisValueAttr="entity" />
        <hr/>

        <p/><p><b>Validators Signing Summary</b></p>
        <BootstrapTable keyField='entity' data={ this.state.data }
          columns={ columns } striped options={options}
          condensed noDataIndication="Table is Empty/Loading"/>
        <OasisNetworkNav />
      </div>
    );
  }
}
// <BaseBarChart title="Blocks Proposed" xAxis="Validator" yAxis="Blocks Signed"
//   showVerticalLabel={false} valueAttr="proposals" showTotalLabel={false}
//   data={this.state.proposalsData} xAxisValueAttr="entity" />
// <hr/>
//
// <StackedBarChart title="Signed / Missed Signatures" xAxis="Validator" yAxis="Blocks Signed/Missed"
//   showVerticalLabel={true} valueAttr="signatures" valueAttr2="notSigned" showTotalLabel={false}
//   data={this.state.signedMissedData} verticalLabel={false}  xAxisValueAttr="entity" />
// <hr/>
//

export default TopBlockSigners;



// WEBPACK FOOTER //
// ./src/network/TopBlockSigners.js